import { render, staticRenderFns } from "./shopSection.vue?vue&type=template&id=22be7a1b&"
import script from "./shopSection.vue?vue&type=script&lang=js&"
export * from "./shopSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports